import type { UserNotification } from "./types";

type NotificationLinkMap<T extends UserNotification["type"]> = {
  [K in T]: (notification: Extract<UserNotification, { type: K }>) => {
    link: string;
  };
};

function createNotificationsLinkMap<T extends UserNotification["type"]>(
  map: NotificationLinkMap<T>
) {
  return map;
}

// TODO: find a way to be exhaustive on the keys (if we add a type in UserNotification, notificationMap shouldn't type-check)
const notificationsLinkMap = createNotificationsLinkMap({
  "ORG/INFO/ORG_PROJECT_ARCHIVE_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/info/profile`,
    };
  },
  "ORG/PROJECT_CREATED_FROM_SPREADSHEET": () => {
    return {
      link: `/dashboard/home`,
    };
  },
  "ORG/ROLE_UPDATED": (notification) => {
    return {
      link: `/org/${notification.payload.org.id}/members`,
    };
  },
  "ORG/USER_INVITED_TO_ORG": (notification) => {
    return {
      link: `/org/${notification.payload.org.id}/members`,
    };
  },
  "PROJECT/CHAT/CHANNEL_CREATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/chat/${notification.payload.channelId}`,
    };
  },
  "PROJECT/CHAT/CHANNEL_MERMBERS_ADDED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/chat/${notification.payload.channelId}`,
    };
  },
  "PROJECT/CHAT/CHANNEL_RENAMED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/chat/${notification.payload.channelId}`,
    };
  },
  "PROJECT/CHAT/FILE_APPROVALS/MESSAGE_RECEIVED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/fileApproval/${notification.payload.fileApproval.id}`,
    };
  },
  "PROJECT/CHAT/MESSAGE_RECEIVED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/chat/${notification.payload.channelId}`,
    };
  },
  "PROJECT/CHAT/PROJECT_DIRECT_MESSAGE_RECEIVED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/chat/${notification.payload.channelId}`,
    };
  },
  "PROJECT/CHAT/TASK/MESSAGE_RECEIVED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_APPROVAL_MODE": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_ASSIGNATIONS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_DELETED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_LABELS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_MOVED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_PERMISSIONS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_REMINDER": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FILE_RENAMED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FINALIZE_UPLOADED_FILE": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/FINALIZE_UPLOADED_FILE_VERSION": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}/version/${notification.payload.file.version.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/REQUESTED_USERS_APPROVALS_ON_FILE": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}/version/${notification.payload.file.version.id}`,
    };
  },
  "PROJECT/DOCUMENT/FILE/USER_APPROVAL_ADDED_TO_FILE_VERSION": (
    notification
  ) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/files/${notification.payload.file.id}/version/${notification.payload.file.version.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FILE_STRUCTURE_CREATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_ASSIGNATIONS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_CREATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_DELETED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/bin/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_LABELS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_MOVED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_PERMISSIONS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/DOCUMENT/FOLDER/FOLDER_RENAMED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/docs/folders/${notification.payload.folder.id}`,
    };
  },
  "PROJECT/MISC/PROJECT_DELETED": () => {
    return {
      link: `/dashboard/home/list`,
    };
  },
  "PROJECT/MISC/ROLE_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/info/members`,
    };
  },
  "PROJECT/MISC/TASKS_CREATED_FROM_SPREADSHEET": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks`,
    };
  },
  "PROJECT/TASK/FINALIZE_UPLOADED_TASK_ATTACHMENT": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/SUBTASK_CREATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/SUBTASK_DELETED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/SUBTASK_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_ARCHIVE_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_ASSIGNATIONS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_ATTACHEMENT_DELETED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_CREATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  // TODO: Maybe send the user to the updated file instead
  "PROJECT/TASK/TASK_FILE_VERSIONS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_LABELS_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_REMINDER": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
  "PROJECT/TASK/TASK_VALIDATION_UPDATED": (notification) => {
    return {
      link: `/project/${notification.payload.project.id}/tasks/${notification.payload.task.id}`,
    };
  },
});

export { notificationsLinkMap };
